import React from 'react';

function TrackingDetails({ ticket }) {
    const { tracking } = ticket;
    
    if (ticket == null) { return <p>No tickets available</p>; }

    // check if active ticket with ticket status

    

    return (
        <div className="home-time-supportDesk-top-wraper" style={{marginTop:"15px", minHeight: "0", maxHeight: "500px", overflowY: "scroll"}}>
            <div className="titleBlock group">
                <h4>Tracking Information</h4>
            </div>
            <div className="informationContainer" style={{minHeight: "0", marginTop: 0}}>
                {tracking.referenceNumber != null ? (
                    <div className="informationRow">
                        <label>Reference Number</label>
                        <span>{tracking.referenceNumber.length > 0 ? tracking.referenceNumber : 'Unavailable'}</span>
                    </div>
                ) : null}
            {tracking.trackingNumber != null ? (
                <div className="informationRow" style={{borderTop: tracking.referenceNumber != null ? "1px solid #fff" : null, paddingTop: tracking.referenceNumber != null ? "10px" : null}}>
                    <label>Tracking Number</label>
                    <span>{tracking.trackingNumber.length > 0 ? tracking.trackingNumber : 'Unavailable'}</span>
                </div>
            ) : null}
            {tracking.packageStatus != null ? (
                <div className="informationRow" style={{borderTop: (tracking.referenceNumber != null || tracking.trackingNumber != null) ? "1px solid #fff" : null, paddingTop: tracking.referenceNumber != null ? "10px" : null}}>
                    <label>Package Status</label>
                    <span>{tracking.packageStatus.length > 0 ? tracking.packageStatus : 'Unavailable'}</span>
                </div>
            ) : null}
            {tracking.packageNotes != null ? (
                <div className="informationRow" style={{borderTop: (tracking.referenceNumber != null || tracking.trackingNumber != null) ? "1px solid #fff" : null, paddingTop: tracking.referenceNumber != null ? "10px" : null, height: "auto", }}>
                    <label>Package Notes</label>
                    <p>{tracking.packageNotes.length > 0 ? tracking.packageNotes : 'Unavailable'}</p>
                </div>
            ) : null}
            </div>
        </div>
    );
}

export default TrackingDetails;